import { useTranslation } from 'react-i18next';
import { Icon, Typography, Button } from '@/components';

export type FinancialHighlightsProps = {
  readonly normalizedProject: any;
  readonly onEdit?: () => void;
  readonly isEditable: boolean;
};

export function FinancialHighlightsBox({ normalizedProject, isEditable, onEdit }: FinancialHighlightsProps) {
  const { t } = useTranslation(['opportunities']);
  const topcoTech = normalizedProject.technologies.find((tech: any) => tech.type === 'topco');
  if (!topcoTech) return null;
  const financialHighlights = normalizedProject.financialHighlights?.[0];

  const fields = [
    {
      label: t('Details'),
      value: financialHighlights?.details,
    },
  ];

  const visibleFields = isEditable
    ? fields
    : fields.filter(({ value }) => value !== null && value !== undefined && value !== '');
  if (!isEditable && visibleFields.length === 0) return null; 


  return (
    <div className="rounded-lg border border-neutral-50 bg-white p-6 shadow-xs">
      <div className="mb-6 flex items-center">
        <div className="flex grow items-center">
          <div className="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-50">
            <Icon name="chart-column-increasing" className="h-6 w-6" />
          </div>
          <Typography as="h3" weight="semibold" size="title">
            {t('Financial Highlights')}
          </Typography>
        </div>
        {isEditable && (
          <Button size="sm" color="neutral" icon="edit" onClick={onEdit} className="ml-auto">
            {t('Edit')}
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1">
        {visibleFields.map(({ label, value }) => (
          <Typography key={label} as="p" size="body-2" weight="semibold" relaxed className="mb-1">
            {label}:{' '}
            <span className="ml-3 text-base font-normal text-neutral-900">{value ?? (isEditable ? '—' : null)}</span>
          </Typography>
        ))}
      </div>
    </div>
  );
}
